import React from "react";
import Paragraphs from "../Article/Paragraphs";

export const Letter = ({ data }) => {
  return (
    <div class="text">
      <div
        style={{
          backgroundColor: "#f7f7f7",
          border: "1px solid #d9d9d9",
          padding: "10px",
        }}
      >
        <Paragraphs data={data} />
      </div>
    </div>
  );
};
